import { GET_SUBSTITUTIONS_SUCCESS } from "../constants";

import initialState from "./initialState";

export default function substitutionsReducer(state = initialState.links, action) {
  if (action.type == GET_SUBSTITUTIONS_SUCCESS) return action.substitutions;
  return state;
}
